import { useEffect, useState } from "react";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { postKmsData } from "@kaltura/mediaspace-shared-utils";
import Notification from "./notification/notification";
import styled from "@emotion/styled";

export interface CategoryNotificationCheckerProps {
    url: string;
}

const StyledAlertWrapper = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "showAlert";
        },
    }
)<{ showAlert: boolean }>(({ theme, showAlert }) => ({
    transform: showAlert ? "scaleY(1)" : "scaleY(0)",
    transformOrigin: "top",
    transition: "transform .5s ease-in-out",
    overflow: "hidden",
}));

export function CategoryNotificationChecker({ url }: CategoryNotificationCheckerProps) {
    const [message, setMessage] = useState<string | null>();
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        postKmsData(url).then((response: { message?: string }) => {
            setMessage(response.message);
        });
    }, [url]);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => setShowAlert(true), 0);
            return () => clearTimeout(timer); // Cleanup timer on effect re-run
        }
    }, [message]);

    return (
        <div>
            <ErrorBoundary fallback={null}>
                <StyledAlertWrapper showAlert={showAlert}>
                    {showAlert && message && <Notification message={message} />}
                </StyledAlertWrapper>
            </ErrorBoundary>
        </div>
    );
}

export default CategoryNotificationChecker;
